import { useEffect } from 'react';
import { useNavigateBack } from '../../../common/hooks/useNavigateBack.js';
import { ForgotPassword } from '../../../components/ForgotPassword/ForgotPassword.js';
import { useAuth } from '../AuthProvider';

export const ForgotPasswordPath = () => {
  const { updateForgotPasswordStepNumber } = useAuth();
  const navigateBack = useNavigateBack();

  const moveToOmaElisa = () => {
    updateForgotPasswordStepNumber(0);
    navigateBack();
  };

  useEffect(() => {
    updateForgotPasswordStepNumber(1);
  }, [updateForgotPasswordStepNumber]);

  return (
    <div className="of-forgot-password-wrapper">
      <div className="ea-snapper-container">
        <div className="of-forgot-password-wrapper__content">
          <ForgotPassword closeModal={moveToOmaElisa} unmountAction={moveToOmaElisa} />
        </div>
      </div>
    </div>
  );
};
